const nginxImageLoader = ({
  src,
  width,
  quality = 75,
}: {
  src: string
  width: number
  quality?: number
}) => {
  return `${src}?width=${width}&quality=${quality}`
}

export default nginxImageLoader
